<template>
  <meta-overlay
    v-model="isVisible"
    append-to-body
    close-by-mark
    transition="tra-slideUpIn"
    placement="bottom-center"
  >
    <div class="share-bg" @click.stop>
      <img
        class="close-icon"
        src="@@/assets/imgs/search_del.png"
        alt="关闭分享弹窗"
        @click="closeShare"
      />
      <div class="title">分享到</div>
      <div class="content">
        <div class="icon-box" @click="share(1)">
          <img class="app-icon" src="@@/assets/imgs/wechat.png" alt="微信分享" />
          <span>微信</span>
        </div>
        <div class="icon-box" @click="share(3)">
          <img class="app-icon" src="@@/assets/imgs/qq.png" alt="QQ分享" />
          <span>QQ</span>
        </div>
        <div class="icon-box" @click="share(6)">
          <img class="app-icon" src="@@/assets/imgs/link.png" alt="复制链接" />
          <span>复制链接</span>
        </div>
      </div>
    </div>
  </meta-overlay>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { showToast } from "vant";
import { copyText } from "~/utils/jsb";

import { tinyurlCreate } from "~/business/alova/methods/goodsPageApi.ts";
import { useRequest } from "alova";

interface ShareData {
  name: string;
  displayImg?: string;
}

interface ShareResponse {
  data: string;
}

interface ShareTypeMap {
  [key: number]: [number, number];
}

interface MetaX {
  exec: (str: string) => void;
}

declare global {
  interface Window {
    MetaX?: MetaX;
  }
}

const isVisible = ref<boolean>(false);
const data = ref<ShareData | null>(null);

/**
 * @description 关闭弹窗
 * @return {void}
 */
const closeShare = (): void => {
  isVisible.value = false;
};

/**
 * @description 打开弹窗
 * @param {ShareData} _data - 分享数据
 * @return {void}
 */
const open = (_data: ShareData): void => {
  isVisible.value = true;
  data.value = _data;
};

/**
 * @description 分享
 * @param {number} type - 分享方式
 * @return {void}
 */
const share = (type: number): void => {
  const params = {
    effectiveTimeSecond: 60 * 60 * 24 * 365 * 8,
    originUrl: navManager.withQuery(window.location.origin + window.location.pathname, {
      source: "share",
      commodityId: sessionStorage.getItem("commodityId")
    })
  };
  const { onSuccess} = useRequest(()=>{return tinyurlCreate(params)})

  onSuccess((res)=>{
    const targetUrl = res?.data?.data;
    if (type === 6) {
      copyText(targetUrl);
      showToast("复制成功，快去分享给好友兑换好礼！");
    } else {
      const ShareType: ShareTypeMap = {
        1: [1, 21],
        3: [3, 31]
      };

      const shareParams = {
        targetUrl,
        title: data.value?.name,
        desc: "来233乐园福利商店，兑换热门游戏礼包，还有更多惊喜神券等你。",
        imgUrl: data.value?.displayImg
          ? data.value.displayImg + "?imageView2/3/w/160/h/160"
          : "https://www.233leyuan.com/opstatic/common/widget/nav/images/logo_icon_e861c6b.png",
        shareType: ShareType[type][0],
        shareStyle: ShareType[type][1],
        isWeb: true,
        locationId: 0
      };

      const obj = { method: "share", param: [shareParams], asyncCallback: "" };
      window.MetaX?.exec(JSON.stringify(obj));
    }

    closeShare();
  })
};

defineExpose({
  open,
  close: closeShare
});
</script>
<style scoped lang="scss">
.share-bg {
  width: 100%;
  background: #fff;
  height: 7.1rem;
  position: relative;
  border-radius: 1rem 1rem 0 0;
  padding: 0.27rem 0 0.64rem 0;

  .close-icon {
    position: absolute;
    right: 0.6rem;
    top: 0.6rem;
    width: 1.03rem;
    height: 1.03rem;
  }

  .title {
    color: #323233;
    font-weight: 600;
    font-size: 0.6rem;
    text-align: center;
    padding: 0.45rem 0 0.68rem 0;
  }

  .content {
    padding: 0 0.8rem;
    color: #585858;
    font-size: 0.52rem;
    display: flex;
    justify-content: space-around;

    .icon-box {
      display: flex;
      flex-direction: column;
      align-items: center;

      .app-icon {
        width: 2.134rem;
        height: 2.134rem;
      }

      span {
        margin-top: 0.7rem;
      }
    }
  }
}
</style>
